module.exports = __webpack_public_path__ + "static/media/stylist-manus.191530c2.svg";